import React, { useContext, useEffect,useState } from 'react'
import { UserContext } from '../../services/Context/Context';
import { ToWords } from 'to-words';
import CardTable from '../PaiementStepVadico/CardTable/CardTable';
import { formatStringNumber, isEmpty } from '../../services/Helpers/fonctions';
import moment from 'moment';
const InvoiceDetailsVadico =  React.forwardRef(({ paiement }, ref) => {  
  const url = process.env.REACT_APP_URL.replace('api/','') + 'storage/';
  const { agence,decoupage,user } = useContext(UserContext);

  const [ quartier,setQuartier ] = useState("");
  const [ commune ,setCommune ] = useState('');
  const [ prefecture,setPrefecture ] = useState('');
  const decoup = decoupage;
  const toWords = new ToWords({
    localeCode: 'fr-FR',
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
    }
  });

  useEffect(() => {
    if( user && decoup ){ 
    const getQuartier = decoup?.quartiers?.find((q) => q.quartier_id === user.quartier_id);
    if( getQuartier ){
      setQuartier(getQuartier);
      const getCommune = decoup?.communes.find( (p) => p.commune_id === getQuartier.commune_id );
      if( getCommune ){
          setCommune(getCommune); 
          const getPrefecture = decoup?.prefectures.find((p) => p.prefecture_id === getCommune.prefecture_id);
          if( getPrefecture ){
              setPrefecture(getPrefecture);
          }
      }
    }
    }
  },[user, decoup]);
  
  return (
    
    <div className='invoice' ref={ref} style={{ width:'100%'}}>
        {( paiement )&&
          <>
         <div className="head">
           <h1>Reçu de Paiement </h1>
           <div className="logo">{
               agence?
               <img src={ url + agence?.logo } style={{width:'85px'}}/>:
             'LOGO'}</div>
         </div>
        
         <div className="bill-details" style={{ marginTop:"-40px"}}>
            <div className="from">
                <span className="subtitle">Par </span>
                <strong>DSD Guinée</strong>
                <p>Agence de { agence?.nom_agence + " / "+ quartier?.nom } </p>
                <span>Prefecture de <span className='gras'>{prefecture?.nom}</span> </span> 
                <p>Commune de {commune?.nom !== "COMMUNE URBAINE" ? <span className='gras'>{commune?.nom}</span>: <span className='gras'>CENTRE</span> }</p>
                <p>Agent : <strong>{ user?.username && user.prenom + " " + user.nom }</strong></p>
            </div>
            <div className="to">
              <span className="subtitle">Client </span>
              <span>Client: <strong> { paiement?.typeClient} </strong></span>
              <span>Dénomination : <strong> { paiement?.nomComplet ? paiement?.nomComplet:paiement.nom ? paiement.nom :"------" }</strong></span>
              <span>Téléphone  : <strong> { paiement?.telephone }</strong></span>
              <span> Mode de Paiement: <strong> {paiement?.mode_paiement && paiement?.mode_paiement.slice(0,1).toUpperCase() + paiement.mode_paiement?.slice(1)}</strong></span>
              <span> Date de Paiement : <strong> { moment().format("Do MMM YYYY") }</strong></span>
              {paiement?.pvnumber && <span> N° PV : <strong> { paiement?.pvnumber }</strong></span>}
            </div> 
          </div>  
          <div style={{ marginTop:""}}>
           <div style={{display:'inline'}}>
             <span style={{fontSize:'18px',}}>Référence : </span> 
             <span style={{fontWeight:'bold',fontFamily:'revert-layer'}}>{ paiement?.reference}</span>
           </div> 
         </div>
          <div className='array' >
             <CardTable data={paiement} />
          </div>
          <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
              <div style={{paddingBottom:'10px'}}>
              <span>Montant TTC : <strong>{formatStringNumber(paiement?.prix || paiement?.price || 0) } </strong>fg</span>
              </div>
              <div><strong>{toWords.convert(parseInt(paiement?.prix || paiement?.price || 0))}</strong> Francs Guinéens</div>
          </div>
          <div className="signature">
            <div>
              <p>Signature de l'agent</p>
            </div>
            <div>
              <p>Signature du client</p>
            </div>
            <div className='qr'>
              <p>QR Code</p>
              <div className='qr-image'>
                <img src={ url + paiement.qrpath } alt='qr-code'/>
              </div>
            </div>
          </div> 
      
        <div className="invoice-footer">
            <p>
              Pour toute information complémentaire, appelez le 624 37 31 14 ou consultez
              le portail internet de SIPIM.{" "}
              <a href="https://support.sipimguinee.com">
              https://support.sipimguinee.com
              </a>
            </p>
            <p>DSD vous remercie.</p>
        </div>
        </>}
    </div>
  )
  
})
export default InvoiceDetailsVadico;
